<div class="tabcontrol">
  <button
    class="tab-header-item"
    tabindex="0"
    (click)="setActiveTab(item.index)"
    *ngFor="let item of steps"
    [ngClass]="item.index === activeStep ? 'active' : ''"
  >
    {{ item.label }}
  </button>
</div>
<ng-content class="w100"></ng-content>
